module.exports = __webpack_public_path__ + "static/img/9.19e4262.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/5/1/sp/9.png
// module id = RKAy
// module chunks = 0